module.exports = __webpack_public_path__ + "img/another_pos.5a373e36.png";